import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";
import { IDemandPayload } from "../../interface/IDemand";

export const onHandSoqApi = createApi({
    reducerPath:"onHandSoqApi",
    baseQuery: axiosBaseQuery(),
    endpoints:(builder)=>({
        getcurrentOnHandVSTargetInventory:builder.mutation({
            query:(payload: any)=>({
                url:"/currentOnHandVSTargetInventory",
                method:"POST",
                data: payload
            })
        }),
        getOnHandVSTargetInventory: builder.mutation({
            query: (payload: any)=>({
                url:"/onHandVSTargetInventory",
                method:"POST",
                data:payload,
            })
        })
    }),
})

export const {
    useGetcurrentOnHandVSTargetInventoryMutation,
    useGetOnHandVSTargetInventoryMutation,
} = onHandSoqApi;